import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AuthWrapper from './pages/Authorization/AuthWrapper';

function App() {

    return (
        <BrowserRouter>
            <AuthWrapper></AuthWrapper>
        </BrowserRouter>
    )
}

export default App;